const items = [
  {
    label: "JavaScript",
    description: `This is a multi-paradigm, prototype-based, dynamic, weakly typed, programming language that I use most often.
      AKA JS and, more formally, <a href="https://en.wikipedia.org/wiki/ECMAScript#6th_Edition_-_ECMAScript_2015" target="_blank">ECMAScript</a>
      or ES6, ES7...`,
    comment: `There's now an annual update cycle`
  }, {
    label: "Babel",
    description: `A <a href="https://babeljs.io/" target="_blank">transpiler</a> for JavaScript 
      best known for its ability to turn proposed language features into code that runs in browsers today.`,
    comment: `must-have`
  }, {
    label: "Webpack",
    description: `A JavaScript module <a href="https://webpack.js.org/" target="_blank">bundler</a>.
      Webpack takes code modules with dependencies and packs them into static assets for delivery across the web.`,
    comment: `Attends to the packaging`
  }, {
    label: "Gatsby",
    description: `A <a href="https://www.gatsbyjs.org/" target="_blank">generator</a> of static Progressive Web Apps (PWA). 
    Gatsby helps build blazing-fast sites by wiring layouts and pages together with data from any source.`,
    comment: `This site uses Gatsby`
  }, {
    label: "HTML5",
    description: `A markup language used for structuring content on the Web. 
    The fifth is the current major version of the <a href="https://en.wikipedia.org/wiki/HTML5" target="_blank">HTML</a> standard.`,
    comment: `Without which there is no web`
  }, {
    label: "CSS3",
    description: `<a href="https://en.wikipedia.org/wiki/Cascading_Style_Sheets" target="_blank">Cascading Style Sheets</a> 
      A language used for describing the presentation of a document written in HTML.`,
    comment: `CSS made the web beautiful`
  }, {
    label: "SCSS",
    description: `A <a href="http://sass-lang.com/" target="_blank">processor</a> providing advanced CSS language features
    that are interpreted into Cascading Style Sheets.`,
    comment: `SCSS helps me write CSS`
  }, {
    label: "JSS",
    description: `JSS provides another <a href="https://en.bem.info/" target="_blank">abstraction</a> over CSS 
    and allows for themes to be developed in JavaScript. Works hand in glove with other tools here like Material-UI and React.`,
    comment: `JSS helps me write CSS too`
  }, {
    label: "React",
    description: `A JavaScript <a href="https://reactjs.org/" target="_blank">library</a> for building user interfaces. 
      By the composition of components React makes it painless to organise the user experience.`,
    comment: `Alternatives ...shmurnatives`
  }, {
    label: "Redux",
    description: `<a href="https://redux.js.org/" target="_blank">State</a> management for Web apps. Rewiring the logic
    Redux + Middleware + React pretty much form the counterpart to traditional MVC, and make it easier to find problems.`,
    comment: `Small library, Big deal.`
  }, {
    label: "Git",
    description: `Git is a <a href="https://en.wikipedia.org/wiki/Git" target="_blank">version control</a> system for tracking changes 
      in files and for coordinating work among many editors.`,
    comment: `Ugly and can't live without it :)`
  }, {
    label: "Github",
    description: `A web-based Git version control hosting service for repositories.`,
    comment: `Here's my <a href="https://github.com/jawford" target="_blank">Github</a>`
  }, {
    label: "GraphQL",
    description: `A query language for APIs. <a href="http://graphql.org/" target="_blank">GraphQL</a> 
    gives clients the power to ask for exactly what they need and nothing more.`,
    comment: `Give me a ping, Vasili. One ping only, please.`
  }, {
    label: "Meteor",
    description: `At one time, the easiest <a href="https://www.meteor.com/" target="_blank">complete</a> 
    tool to use for building apps. Has its own network layer, and is fixed on MongoDB for its database.`,
    comment: `Still in production`
  }, {
    label: "Node",
    description: `A server side <a href="hhttps://nodejs.org/en/" target="_blank">runtime</a> for 
      JavaScript code. Running frameworks like Express, Hapi & Koa, it powers APIs.`,
    comment: `"Popular choice"`
  }, {
    label: "NPM",
    description: `A Node package <a href="https://www.npmjs.com/" target="_blank">manager</a>
      for the JavaScript programming language.`,
    comment: `Once more a thing, despite Yarn`
  }, {
    label: "Python",
    description: `Readable, flexible and dynamic programming <a href="https://www.python.org/" target="_blank">language</a>.
    Useful in general programming, backend applications for the web, and now in machine learning.`,
    comment: `A nice working experience`
  }, {
    label: "AWS AppSync",
    description: `One from the <a href="https://aws.amazon.com/" target="_blank">Amazon</a> stable of services.
    Providing realtime / reactive data to many simultaneous users`,
    comment: `Like GraphQL meets Firebase + Lambda`
  }, {
    label: "C#",
    description: `Microsoft's reply to Java. Loads of new ideas and 
    <a href="https://en.wikipedia.org/wiki/C_Sharp_(programming_language)" target="_blank">features</a> over the years`,
    comment: `Great language, tools and ecosystem`
  }, {
    label: "Java",
    description: `The first cross-platform object-oriented-programming <a href="https://www.java.com/" target="_blank">language</a>.
    For writing desktop UIs, then. And now server side logic as microservices. Massively architected.`,
    comment: `Much maligned. Much loved.`
  }, {
    label: "Docker",
    description: `Manages a container format for building and moving applications around on the web. 
    Plenty of <a href="https://en.wikipedia.org/wiki/Docker_(software)" target="_blank">tools</a> in the ecosystem`,
    comment: `More apps per square server than VMs`
  }, {
    label: "C++",
    description: `A freaky fast systems programming <a href="https://en.wikipedia.org/wiki/C%2B%2B" target="_blank">language</a> designed primarily 
      for engineering applications and our desktop software like MS Office. Majorly useful close to the tin.`,
    comment: `Web Assembly might bring it to the, er, web`
  }, {
    label: "GCP / GAE",
    description: `Google App Engine, the venerable, the scalable. The <a href="https://cloud.google.com/appengine/" target="_blank">platform</a>
    for apps with accounts, email, Datastore and more.`,
    comment: `Pythonistas' batteries included`
  }, {
    label: "AngularJS",
    description: `One time leader in the framework space for Model View Controller (<a href="https://angularjs.org/" target="_blank">MVC</a>) apps. 
    Radically re-released as a TypeScript-based highly opinionated, complete and easy-to-use framework.`,
    comment: `1.x in its day was like wow`
  }, {
    label: "PHP",
    description: `A server-side scripting <a href="http://php.net/" target="_blank">language</a> designed primarily 
    for small web site development but also used as a general-purpose programming language.`,
    comment: ``
  }, {
    label: "Other Developers",
    description: `To those generously writing up their experiences, who help define best practice, techniques & patterns...`,
    comment: `Thank you`
  }, {
    label: "Training",
    description: `I used to be a trainer for programming languages, a long time back. 
    Blogging and videos don't put people in front of you in quite the same way.`,
    comment: `Still, in the toolbox`
  }
]

export default items.map( (item, idx) => {
  item.id = idx
  return item
})



// WEBPACK FOOTER //
// ./src/content/toolbox-list.js